import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CtrCalculator"] */ "/vercel/path0/src/app/dienstleistungen/seo/ctr-calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQAccordion"] */ "/vercel/path0/src/components/home/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HoverInfo"] */ "/vercel/path0/src/components/HoverInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SerpCtrMockup","LocalMapsMockup"] */ "/vercel/path0/src/components/mockups/service-mockups.tsx");
